(() => {
  if (customElements.get('product-barcode')) {
    return;
  }

  class ProductBarcode extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.querySelector('[data-button-open]').addEventListener(
        'click',
        this.toggle.bind(this),
      );
      this.querySelector('[data-button-close]').addEventListener(
        'click',
        this.toggle.bind(this),
      );
    }

    init() {
      if (!this.dataset.barcode) return;
      JsBarcode(this.querySelector('#barcode'), this.dataset.barcode);
      JsBarcode(this.querySelector('#barcode-main'), this.dataset.barcode);
    }

    toggle() {
      this.querySelector('[data-code]').classList.toggle('hidden');
    }
  }

  customElements.define('product-barcode', ProductBarcode);
})();
